package br.com.vvrefeicoes.portal.core.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.logo_portal

private const val LOGO_ASPECT_RATIO = 119f / 29f

@Composable
fun AppLogo(modifier: Modifier = Modifier) {
    Image(
        painter = painterResource(Res.drawable.logo_portal),
        contentDescription = null,
        modifier =
            modifier
                .widthIn(max = 295.dp)
                .fillMaxWidth(0.9f)
                .aspectRatio(LOGO_ASPECT_RATIO),
        contentScale = ContentScale.Fit,
    )
}

@Composable
fun AppLogoWhite(
    modifier: Modifier = Modifier,
    contentDescription: String? = null,
) {
    Image(
        painter = painterResource(Res.drawable.logo_portal),
        contentDescription = contentDescription,
        modifier = modifier.aspectRatio(LOGO_ASPECT_RATIO),
        contentScale = ContentScale.Fit,
        colorFilter = ColorFilter.tint(Color.White),
    )
}
